// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608250605/js/" + chunkId + "." + {"44":"0bf97a21","225":"be5eb798","481":"3ededea5","486":"842ee903","770":"96e4a2fd"}[chunkId] + ".0.9146713937455054.chunk.js";
};